import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-desktop-warning',
    templateUrl: './desktop-warning.component.html',
    styleUrls: ['./desktop-warning.component.scss'],
})
export class DesktopWarningComponent implements OnInit {
  phoneMockupExists = true;
  funIconExists = true;

  constructor() { }

  ngOnInit(): void {
  }

}
